module.exports = __webpack_public_path__ + "sunsemweb/img/phone_zxzx.b07f51a5.png";